import { assign } from 'lodash'
import { VtjErrorParams } from 'common/src/vtj/VtjError.type'

export class KoodistoTypeError extends Error {
  constructor({ message, ...rest }: VtjErrorParams = {}) {
    super(message)
    Object.setPrototypeOf(this, new.target.prototype)
    this.name = this.constructor.name
    assign(this, rest)
  }
}

export class KoodistoCodeError extends Error {
  constructor({ message, ...rest }: VtjErrorParams = {}) {
    super(message)
    Object.setPrototypeOf(this, new.target.prototype)
    this.name = this.constructor.name
    assign(this, rest)
  }
}

export class KoodistoError extends Error {
  constructor({ message, ...rest }: VtjErrorParams = {}) {
    super(message)
    Object.setPrototypeOf(this, new.target.prototype)
    this.name = this.constructor.name
    assign(this, rest)
  }
}
